import { ConsentString } from 'consent-string';

interface MapObject {
    [key:string]: any
}

declare global {
    interface Window { __cmp: Function | undefined; }
}

export const removeNullParams = (params:MapObject) => {
  return Object.keys(params)
    .filter(key => params[key] !== null && typeof params[key] !== 'undefined')
    .reduce((acc, key) => ({
      ...acc,
      [key]: params[key],
    }), {});
};

export function getCookieByName(name:string) {
  // @ts-ignore
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}

export function setCookie(name:string, value:string | number) {
  document.cookie = `${name}=${value}`;
}

export function readPublisherConsentCookie() {
  return getCookieByName('eupubconsent');
}

export function readVendorsConsentCookie() {
  return getCookieByName('euconsent');
}

export function readGooglePersonalizationCookie() {
  return getCookieByName('googlepersonalization');
}

function repeat(count: number, string = '0') {
  let padString = '';

  for (let i = 0; i < count; i += 1) {
    padString += string;
  }

  return padString;
}

function padLeft(string:string, padding: number) {
  return repeat(Math.max(0, padding)) + string;
}

export function getShouldNotGooglePersonalizeAds(googlePersonalizationString: string) {
  if (!googlePersonalizationString) {
    return true;
  }
  const bstr = atob(googlePersonalizationString);
  let inputbits = '';
  for (let i = 0; i < bstr.length; i += 1) {
    const bitString = bstr.charCodeAt(i).toString(2);
    inputbits += padLeft(bitString, 8 - bitString.length);
  }
  return inputbits[72] === '0';
}

export function getAnalyticsConsent(consentString:string) {
  const consentData = new ConsentString(consentString);
  const measurementPurpose = 17;
  // @ts-ignore
  return !!consentData.getPurposesAllowed().find(purpose => purpose === measurementPurpose);
}

export function getGdprApplies() {
  return getCookieByName('gdprApplies') || '1';
}

export function updateGdprApplies() {
  // eslint-disable-next-line no-underscore-dangle
  if (typeof window.__cmp === 'undefined') {
    throw new Error('window doesn\'t have __cmp');
  }
  // eslint-disable-next-line no-underscore-dangle
  window.__cmp('getConsentData', null, (data:{gdprApplies: any}, success:boolean) => {
    if (success) {
      setCookie('gdprApplies', data.gdprApplies ? 1 : 0);
    }
  });
}
